<img [src]="img" class="video-preview-img" alt="">
<div class="video-preview-time" youtube-duration append-duration>{{ time }}</div>
<div id="youtube-time-description" class="sr-only" tabindex="0"></div>
<mat-icon [svgIcon]="'play'" class="square-icon play-icon"></mat-icon>
